export interface Resource {
  slug: string
  title: string
  summary: string
  format: string
  pages: number
  cover: string
  coverAlt: string
  whatIsInside: string[]
  forWho: string
  fileName: string
  /**
   * Public copy of the file, used only until the signed download route on
   * files.cavalladata.com is live. Once LIVE_API is on, the signed URL wins.
   */
  hostedFileUrl?: string
  hubspotList: string
  hubspotSequence: string
}

export const RESOURCES: Resource[] = [
  {
    slug: 'augmented-intelligence-playbook',
    title: 'The Augmented Intelligence Playbook',
    summary:
      'A practical guide to putting AI to work inside an African organisation, written for executives who have to answer to a board.',
    format: 'eBook, PDF',
    pages: 23,
    cover: 'https://cdn.magicpatterns.com/patterns/generated-images/5d12b67a-bc01-4f45-9fe9-2fd5d5142dd0.jpg',
    coverAlt: 'Navy and gold eBook cover for The Augmented Intelligence Playbook',
    whatIsInside: [
      'The four step method we use on every engagement, set out so your team can run it',
      'The five dimension readiness assessment, with the scoring bands',
      'Nine worked use cases across banking, health, government and agriculture',
      'A governance template covering review, accountability and appeal',
      'A two year cost model for running an AI capability, not just building one',
    ],
    forWho: 'Executives, strategy leads and programme owners deciding where to start with AI.',
    fileName: 'cavalla-augmented-intelligence-playbook.pdf',
    hostedFileUrl: 'https://cdn.magicpatterns.com/uploads/iV2hbjM1BmXwuXMiqTL1tT/cavalla-augmented-intelligence-playbook.pdf',
    hubspotList: 'Playbook downloads',
    hubspotSequence: 'AI line nurture',
  },
  {
    slug: 'africa-demand-map-2028',
    title: 'Africa Demand Map to 2028',
    summary:
      'Where demand sits today and where the value moves by 2028, read across ten priority sectors with the sources named.',
    format: 'Report, PDF',
    pages: 32,
    cover: 'https://cdn.magicpatterns.com/patterns/generated-images/699e5a7a-400b-41de-b35f-6923b525b29a.jpg',
    coverAlt: 'Cover artwork for the Africa Demand Map to 2028 report',
    whatIsInside: [
      'Sector by sector demand today, with spend concentration named',
      'Where value moves by 2028 and what triggers the shift',
      'The three constraints that most often delay capture',
      'A one page brief per sector you can take into a planning session',
    ],
    forWho: 'Strategy teams, investment committees and commercial leaders planning the next three years.',
    fileName: 'cavalla-africa-demand-map-2028.pdf',
    hubspotList: 'Demand map downloads',
    hubspotSequence: 'Intelligence line nurture',
  },
  {
    slug: 'go-to-market-checklist',
    title: 'The Go-to-Market Readiness Checklist',
    summary:
      'Forty checks across segment, offer, pricing, channel and measurement, used before we sign off any launch plan.',
    format: 'Checklist, PDF',
    pages: 12,
    cover: 'https://cdn.magicpatterns.com/patterns/generated-images/8a2ab498-4d6e-4c00-b5a1-7944b119629a.jpg',
    coverAlt: 'Cover artwork for the Go-to-Market Readiness Checklist',
    whatIsInside: [
      'Forty checks grouped across the five layers of a launch plan',
      'The four failure patterns we see most often, and their early signals',
      'A scoring sheet so a team can agree where the plan is weak',
    ],
    forWho: 'Commercial leaders and founders preparing to enter a new market or launch a new offer.',
    fileName: 'cavalla-go-to-market-checklist.pdf',
    hubspotList: 'Checklist downloads',
    hubspotSequence: 'Growth line nurture',
  },
]

export function getResource(slug: string): Resource | undefined {
  return RESOURCES.find((resource) => resource.slug === slug)
}
